import React from 'react';
import { ReactDOM } from 'react';
import Axios from 'axios';

export const apiLaravel = Axios.create({
  baseURL: 'https://admin-laravel.gips-cloud.com/',
});

// export default apiLaravel;